export default __webpack_public_path__ + "static/media/Hair_5_M_C2.f86d4362.svg";